var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start"
  }, [_c('video-dialog', {
    attrs: {
      "hash": "#comedy-roast",
      "poster": "https://d3ivhmcqxvlmhm.cloudfront.net/group-video-template/c02e39f8-92ab-42de-8cb9-71bf0bce37b5/poster_6cafbc3d-9a94-40da-9998-eb1b318d51f1.jpg",
      "src": "https://d3ivhmcqxvlmhm.cloudfront.net/group-video/b9721877-fed3-440c-880d-fe471cb443ff/r/17bdbfdf-13a2-4ee6-a62a-ee1254be890e.mp4"
    }
  }), _c('video-dialog', {
    attrs: {
      "hash": "#romantic-slideshow",
      "poster": "https://cdn.ellacard.com/group-video-template/6dfc737b-eb5e-489d-9f19-337ca518e065/poster_4bec968d-f832-4494-a0c0-8997f03eca86.jpg",
      "src": "https://cdn.ellacard.com/group-video/5f37640d-50e4-4a18-8cee-9ce5e392cf90/r/252115d5-96d1-4e2a-ac7e-99033fb086ed.mp4"
    }
  }), _c('video-dialog', {
    attrs: {
      "hash": "#memorial-eulogy",
      "poster": "https://d3ivhmcqxvlmhm.cloudfront.net/group-video-template/56007696-095a-45dc-aacf-8f6994bcc87a/poster_912bb482-8790-49dd-b943-0ed2f0ac91b9.jpg",
      "src": "https://cdn.ellacard.com/group-video/6e1c2680-84a8-4bdb-b923-ad6a3f3ce485/r/bea8dcd6-2bc6-4623-94e0-e73f3bf2937c.mp4"
    }
  }), _c('video-dialog', {
    attrs: {
      "hash": "#graduation",
      "poster": "https://d3ivhmcqxvlmhm.cloudfront.net/group-video-template/49a43bad-9ecf-423f-8929-0b8ff6532745/poster_f87c459b-c259-4361-b3e5-67ed55edd3b7.jpg",
      "src": "https://d3ivhmcqxvlmhm.cloudfront.net/group-video/d2b7371d-def7-40f6-ab3e-aebc5fbcdce9/r/91e754a6-f0e5-4e48-a0a8-b4490e8e45be.mp4"
    }
  }), _c('start-header', {
    attrs: {
      "media": {
        id: 'e4ccfbb2-ae92-4e43-8238-47252dca0856',
        alt: 'Video maker example',
        video: true
      },
      "bg": {
        src: 'https://cdn.ellacard.com/page_backgrounds/Comic Book.mp4',
        color: '#f8d96d'
      },
      "to": {
        name: 'catalog-video'
      }
    },
    scopedSlots: _vm._u([{
      key: "h1",
      fn: function () {
        return [_vm._v("Make an instant "), _c('i', [_vm._v("group")]), _vm._v(" video for any occasion")];
      },
      proxy: true
    }, {
      key: "h2",
      fn: function () {
        return [_vm._v("Pick a theme, add photos and videos, invite friends / family to add, and it all works instantly in your browser")];
      },
      proxy: true
    }])
  }), _c('start-layer', {
    attrs: {
      "clip-waves-class": "light-gradient",
      "offset": .75
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-video'
      }
    }
  }, [_vm._v("Start a video "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "d-block hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "02e6cdb6-c332-4839-a74d-32e3944f7722",
      "alt": "Example comedy night roast preview",
      "is-video": "",
      "title": "Example comedy night roast",
      "to": {
        hash: '#comedy-roast'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("A comedy roast for your dad's big birthday")]), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("Invite all your relatives to contribute, no matter where they live")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "Example comedy night roast",
      "to": {
        hash: '#comedy-roast'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  }), _vm._v(" Demo… ")], 1), _c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'video-template',
        params: {
          templateId: '3050426e-f102-4978-af9c-9b67eb2f4b0f'
        }
      }
    }
  }, [_vm._v("Make this video "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "db90bfa0-ed03-471b-b4b5-8c3b5299dd7e",
      "alt": "Example anniversary slideshow preview",
      "is-video": "",
      "title": "Example anniversary slideshow",
      "to": {
        hash: '#romantic-slideshow'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("A romantic slideshow for your anniversary")]), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v(" Make a cute, romantic slideshow with upbeat music to remind your significant other how you feel. Include your own photos and video messages. ")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "Example anniversary slideshow",
      "to": {
        hash: '#romantic-slideshow'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  }), _vm._v(" Demo… ")], 1), _c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'video-template',
        params: {
          templateId: '6dfc737b-eb5e-489d-9f19-337ca518e065'
        }
      }
    }
  }, [_vm._v("Make this video "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "42f85eb0-f87a-412e-b6bf-72f1a28033c0",
      "alt": "Example eulogy slideshow preview",
      "is-video": "",
      "title": "Example eulogy slideshow",
      "to": {
        hash: '#memorial-eulogy'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("A touching memorial eulogy")]), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("Add photos and record video messages to celebrate the life of someone important to you")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "Example eulogy slideshow",
      "to": {
        hash: '#memorial-eulogy'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  }), _vm._v(" Demo… ")], 1), _c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'video-template',
        params: {
          templateId: '56007696-095a-45dc-aacf-8f6994bcc87a'
        }
      }
    }
  }, [_vm._v("Make this video "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "1ade447b-e095-4f82-9c71-4ca28fd9f026",
      "alt": "Example graduation video preview",
      "is-video": "",
      "title": "Example graduation celebration",
      "to": {
        hash: '#graduation'
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("A graduation celebration")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v(" Congratulate your new grad with photos and video messages from everyone they know, all arranged automatically with exciting effects ")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "Example graduation celebration",
      "to": {
        hash: '#graduation'
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  }), _vm._v(" Demo… ")], 1), _c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'video-template',
        params: {
          templateId: '736ff318-f768-4339-a84a-d0382ec62a34'
        }
      }
    }
  }, [_vm._v("Make this video "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)])], 1), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-video'
      }
    }
  }, [_vm._v(" Start a video "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "gold-gradient",
      "offset": .9
    }
  }, [_c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "60669790-049f-4204-8c73-eec10d65dc5d",
      "alt": "Example of opening a standalone video",
      "is-video": ""
    }
  }), _c('div', [_c('h4', [_vm._v("Send your video as an Ellacard for the perfect presentation")])]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "1.65"
    }
  }, [_c('web-media', {
    staticClass: "absolute rounded black",
    staticStyle: {
      "width": "94%",
      "top": "0",
      "left": "3%"
    },
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "1ade447b-e095-4f82-9c71-4ca28fd9f026",
      "alt": "Example graduation video preview",
      "is-video": ""
    }
  }), _vm._l(_vm.SHARE_ICONS, function (_ref, i) {
    var icon = _ref[0],
      title = _ref[1],
      color = _ref[2];
    return _c('v-btn', {
      key: i,
      staticStyle: {
        "bottom": "0",
        "width": "12%",
        "height": "unset",
        "aspect-ratio": "1"
      },
      style: {
        left: 123 * i / 7 + '%'
      },
      attrs: {
        "absolute": "",
        "fab": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "large": "",
        "color": color
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _c('span', {
      staticClass: "btn-tooltip bottom"
    }, [_vm._v(_vm._s(title))])], 1);
  })], 2), _c('div', [_c('h4', [_vm._v("Or download / share your video on YouTube, Facebook, etc.")])])], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "green-creative-supplies",
      "offset": .9
    }
  }, [_c('h2', {
    staticClass: "mb-16 text-center"
  }, [_vm._v("Custom video templates")]), _c('h4', {
    staticClass: "mt-16 mx-auto text-center"
  }, [_vm._v("Have a use case that's not addressed by one of our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-video'
      }
    }
  }, [_vm._v("existing video templates")]), _vm._v("? We make custom video templates for any project. Price varies based on complexity; contact us for more details: "), _c('a', {
    attrs: {
      "href": "mailto:contact@ellacard.com"
    }
  }, [_vm._v("contact@ellacard.com")])], 1)]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "dark-gradient",
      "offset": .5
    }
  }, [_c('h2', [_vm._v("For business")]), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "d-block hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "66aea453-adf2-4be5-a64d-8a58a83c1b01",
      "alt": "Example corporate holiday group video",
      "is-video": "",
      "title": "Enhance workplace culture with a personalized holiday video from leadership",
      "to": {
        name: 'blog-post',
        params: {
          urlTitle: 'enhance-workplace-culture-with-a-personalized-holiday-video-from-leadership'
        }
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("A group holiday video from leadership")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v(" Executives with busy schedules are hard to get a hold of. Learn how companies use annual holiday videos from leadership to strengthen their connection with employees and foster a sense of unity across the organization. ")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "Enhance workplace culture with a personalized holiday video from leadership",
      "to": {
        name: 'blog-post',
        params: {
          urlTitle: 'enhance-workplace-culture-with-a-personalized-holiday-video-from-leadership'
        }
      }
    }
  }, [_vm._v("Read blog post "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('web-media', {
    staticClass: "d-block hover-pop rounded black",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "880e1d35-b7e5-4723-b2ed-9e3bafcc63c2",
      "alt": "Example candidate offer video",
      "is-video": "",
      "title": "Why job offer videos are the secret weapon for competitive hiring",
      "to": {
        name: 'blog-post',
        params: {
          urlTitle: 'why-job-offer-videos-are-the-secret-weapon-for-competitive-hiring'
        }
      }
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Extend compelling offers to interview candidates")]), _c('div', {
    staticClass: "mb-6"
  }, [_vm._v(" Top candidates have their choice of jobs. Learn how companies are using Ellacard's video maker to share their team's excitement with candidates in the form of branded custom job-offer videos. ")]), _c('div', {
    staticClass: "ma-n2"
  }, [_c('v-btn', {
    staticClass: "btn-pop ma-2",
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "title": "Why job offer videos are the secret weapon for competitive hiring",
      "to": {
        name: 'blog-post',
        params: {
          urlTitle: 'why-job-offer-videos-are-the-secret-weapon-for-competitive-hiring'
        }
      }
    }
  }, [_vm._v("Read blog post "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)])], 1)]), _c('start-reviews', {
    attrs: {
      "tag": "VI"
    }
  }), _c('start-footer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }